// extracted by mini-css-extract-plugin
export default {"dateHeader":"MonthlyScores_dateHeader__dAHkS","combinedScoresHeader":"MonthlyScores_combinedScoresHeader__b45+s","combinedScoresPercent":"MonthlyScores_combinedScoresPercent__UAxGa"};